import types from '../types';

const initialState = {
  autoSaving: false,
  autoSavingPending: false,
  autoSaved: true,
};

const autoSaving = (state = initialState, action) => {
  switch (action.type) {
    case types.reducerTypes.SURVEY_SAMPLE_DIMENSION_AUTO_SAVING: {
      if (!state.autoSavingPending) return state;
      return {
        ...state,
        autoSaving: true,
        autoSaved: false,
        autoSavingPending: false,
      };
    }
    case types.reducerTypes.SURVEY_SAMPLE_DIMENSION_AUTO_SAVED: {
      return {
        ...state,
        autoSaving: false,
        autoSaved: true,
        autoSavingPending: false,
      };
    }
    case types.reducerTypes.SURVEY_AUTO_SAVING_PENDING: {
      return {
        ...state,
        autoSavingPending: true,
      };
    }
    default:
      return state;
  }
};

export default autoSaving;
